import { compact, map } from 'lodash';
import { OpportunityType } from './Opportunity.enum';
import OpportunityConfiguration from './OpportunityConfiguration';
import type { IOpportunity } from './Opportunity.interface';

export default class Opportunity implements IOpportunity {
  configuration: Array<OpportunityConfiguration>;
  type: OpportunityType;

  static build = (data: IOpportunity) => new Opportunity(data);
  static blank = () => new Opportunity();

  /**
   * Constructor
   * @param {IOpportunity} data
   */
  constructor(data?: IOpportunity) {
    this.configuration = compact(
      map(data?.configuration, (obj) => new OpportunityConfiguration(obj))
    );
    this.type = OpportunityType.of(data?.type?.name);
  }
}
